module.exports = __webpack_public_path__ + "static/media/no-profile.79a5000f.png";